import { FC } from 'react';

import type {
  CustomFieldValueType,
  CustomFieldValueWithDefinition,
} from '@vy/custom-fields-types';

import { EditableCustomFieldValueCell } from '../../../../../../components/custom-fields/EditableCustomFieldValueCell';
import { useContractCustomFieldActions } from './hooks/use-contract-custom-field-actions';

type ContractCustomFieldEditableCellProps = {
  row: CustomFieldValueWithDefinition;
  contractId: string;
};

const DEFAULT_VALUE_TYPE: CustomFieldValueType = 'String';

export const ContractCustomFieldEditableCell: FC<ContractCustomFieldEditableCellProps> = ({
  row,
  contractId,
}) => {
  const { saveCustomFieldValue } = useContractCustomFieldActions(contractId);

  return (
    <EditableCustomFieldValueCell
      value={row.value}
      valueType={row.definition?.valueType ?? DEFAULT_VALUE_TYPE}
      onCommit={(updatedValue) => saveCustomFieldValue(row.customFieldDefinitionId, updatedValue)}
      dataVyPrefix={`contract-custom-field-value-${row.customFieldDefinitionId}`}
      showConfirmButtons
    />
  );
};
